//import $ from 'jquery';

import { View } from 'backbone';
import template  from 'dashboard/forms/modal/confirm-delete-modal.ejs';
import RestService      from 'RestService.js';
import ListService      from 'ListService.js';
import NotificationService from 'NotificationService.js';
import eventBus  from 'EventBus.js';
import undoService from 'UndoService.js'
import constants from 'Constants.js'
import textConstants from 'TextConstants';
import util    from 'util/Util.js';

class ConfirmDeleteModal extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#confirmDeleteModal";

        this.setModalTitle();
        this.model.set('confirmDelete', '');

        return this;
    }

    setModalTitle() {
        const mode = this.model.get('mode');
        let deleteTitle = '';
        switch (mode) {
            case 'deleteForm':
                deleteTitle = 'Delete App';
                break;
            case 'deletePrevious':
                deleteTitle = 'Delete Previous Versions';
                break;
            case 'deleteDraft':
                deleteTitle = 'Delete Draft Instances';
                break;

            case 'deleteMobileForm':
                deleteTitle = 'Delete Mobile App';
                break;
            case 'deletePreviousMobileForm':
                deleteTitle = 'Delete Previous Mobile Versions';
                break;
        }
        this.model.set('deleteTitle', deleteTitle);
    }

    displayModalTexts() {
        const mode = this.model.get('mode');
        let text1, text2;
        switch (mode) {
            case 'deleteForm':
                text1 = 'Are you sure you want to delete this app, including all previous versions?';
                text2 = "This deletion can be reversed by clicking the 'Undo' icon. However, it can no longer be reversed after you have logged out.";
                $('button.btn-select-field').button("enable");
                $('#confirmPanel').hide();
                break;
            case 'deletePrevious':
                text1 = 'Are you sure you want to delete all previous versions and instances of this app?';
                text2 = 'This action cannot be reversed!';
                $('#confirmPanel').show();
                break;
            case 'deleteDraft':
                text1 = 'Are you sure you want to delete all draft instances of this app?';
                text2 = 'This action cannot be reversed!';
                $('#confirmPanel').show();
                break;

            case 'deleteMobileForm':
                text1 = 'Are you sure you want to delete this mobile app design?';
                text2 = "This deletion can be reversed by clicking the 'Undo' icon. However, it can no longer be reversed after you have logged out.";
                $('button.btn-select-field').button("enable");
                $('#confirmPanel').hide();
                break;

            case 'deletePreviousMobileForm':
                text1 = 'Are you sure you want to delete all previous versions of this mobile app?';
                text2 = 'This action cannot be reversed!';
                $('#confirmPanel').show();
        }
        $('#text1').html(text1);
        $('#text2').html(text2);
    }


    confirmDelete() {
        let result = '';
        const mode = this.model.get('mode');
        switch (mode) {
            case 'deleteForm':
                result = this.deleteForm().then(()=>{
                    undoService.add({
                        redo: () => {
                            this.deleteForm();
                        },
                        undo: () => {
                            this.unDeleteForm();
                        }
                    }, textConstants.UNDO_DELETE_FORM)
                });
                break;
            case 'deletePrevious':
                this.deleteFormPreviousInstances();
                break;
            case 'deleteDraft':
                result = this.deleteFormDraftInstances();
                break;
            case 'deleteMobileForm':
                result = this.deleteMobileForm(1).then(()=>{
                    undoService.add({
                        redo: () => {
                            this.deleteMobileForm(1)
                        },
                        undo: () => {
                            this.unDeleteMobileForm();
                        }
                    }, textConstants.UNDO_DELETE_FORM)
                });
                break;
            case 'deletePreviousMobileForm':
                result = this.deleteMobileForm(2);
                break;
        }
        return result;
    }

    deleteMobileForm(version) {
        const formId = this.model.get('formId');
        return RestService.deleteMobileForm(formId, version).then((data) => {
                NotificationService.success(`${this.model.get('formName')} was deleted. Clicking undo restores it.`);
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    unDeleteMobileForm() {
        const
            formId = this.model.get('formId'),
            formName = this.model.get('formName');

        return RestService.unDeleteMobileForm(formId).then( data => {

            NotificationService.success(`Mobile App ${formName} was restored`);
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }


    deleteForm() {
        const formId = this.model.get('formId');
        return RestService.deleteForm(formId).then((data) => {
            if(ListService.activeDashboardTab === 'forms') {
                eventBus.trigger('loadFormsView');
            }
            else {
                NotificationService.success(`${this.model.get('formName')} was deleted. Clicking undo restores it.`);
            }
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    unDeleteForm(){
        const
            formId = this.model.get('formId'),
            formName = this.model.get('formName'),

            groupId =  this.model.get('groupId') ? this.model.get('groupId').toString() : undefined,
            groupType = this.model.get('groupType');

           let groupIdToUse = groupId && groupId.includes(formId) ? null : groupId;


        return RestService.unDeleteForm(formId).then( data => {
            let dataTarget = groupIdToUse ? `#well${groupIdToUse}` : constants.EDIT_FORMS_CONTAINER;
            if(ListService.activeDashboardTab === 'forms') {
                eventBus.trigger(constants.EV_OPEN_UNDELETED_FORM_DETAILS,
                    formId,
                    formName,
                    groupType,
                    groupIdToUse,
                    groupType,
                    groupIdToUse,
                    dataTarget
                    );
            }
            else{
                NotificationService.success(`App ${formName} was restored.`);
            }
            return (data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    deleteFormDraftInstances() {
        const formId = this.model.get('formId');

        RestService.deleteFormDraftInstances(formId).then((data) => {
            eventBus.trigger('deletingDraftInstance', formId);
            return(data);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    deleteFormPreviousInstances() {
        const formId = this.model.get('formId');
        const groupType =  this.model.get('groupType');
        const itemId = `${groupType}-${formId}`;

        RestService.deleteFormPreviousVersions(formId).then((data) => {            
            eventBus.trigger(constants.EV_UPDATE_FORM_DETAILS, formId, groupType, itemId);
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            console.log(error);
        });
    }



    getConfirmText(e){
        let word = e.currentTarget.value;
        if (word.toLowerCase() === 'confirm'){
            $('button.btn-select-field').button("enable");
        } else {
            $('button.btn-select-field').button("disable");
        }
    }

    bindEvents() {
        $("#confirmDelete").on('keyup', (e)=>{
            this.getConfirmText(e);
        });
    }

    unbindEvents() {
        $("#confirmDelete").off();
    }

    closeModal() {
        $(this.El).remove(); 
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            let self = this;
            let height = 'auto';
            if (self.model.get('mode') !== 'deleteForm'){
                height = 330;
            }

            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: height,
                width: 450,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-field',
                        'disabled': true,
                        click: () => {
                            self.unbindEvents();
                            this.dialog.dialog( "close" );
                            resolve(self.confirmDelete());
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.dialog.dialog("close");
                            this.closeModal();
                            reject('cancel');
                        }
                    }
                ],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () =>{
                    self.bindEvents();
                    self.displayModalTexts()
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
            this.delegateEvents();
            return this;
        });
    }

}

export default ConfirmDeleteModal;
